"use client";

import { Blog } from "@/types/blog";
import Link from "next/link";
import { Calendar, User, Tag } from "lucide-react";

const SingleBlog = ({ blog }: { blog: Blog }) => {
  const { title, paragraph, author, tags, publishDate } = blog;

  return (
    <div
      data-aos="zoom-in"
      data-aos-duration="600"
      className="group shadow-one hover:shadow-two dark:bg-dark dark:hover:shadow-gray-dark relative overflow-hidden rounded-xl bg-white p-6 transition-all duration-300"
    >
      <div className="mb-4 flex items-center gap-2">
        <Tag className="text-primary h-4 w-4" />
        <span className="text-primary text-sm font-medium">{tags[0]}</span>
      </div>

      <h3 className="text-dark mb-3 text-xl font-bold dark:text-white">
        <Link
          href="#"
          className="hover:text-primary dark:hover:text-primary transition-colors duration-300"
        >
          {title}
        </Link>
      </h3>

      <p className="text-body-color mb-6 text-base leading-relaxed">
        {paragraph}
      </p>

      <div className="border-body-color/10 flex items-center justify-between border-t pt-4 text-sm dark:border-white/10">
        <div className="flex items-center gap-2">
          <User className="h-4 w-4 text-gray-500" />
          <span className="text-gray-700 dark:text-gray-300">
            {author.name} ({author.designation})
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4 text-gray-500" />
          <span className="text-gray-700 dark:text-gray-300">
            {publishDate}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SingleBlog;
